import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import reicon from '../../assets/main/reicon.png';
import write from '../../assets/main/write.png';
import recom from '../../assets/main/recom.png';

import center from '../../assets/main/center.png';
import { useEffect } from "react";
import * as util from "../../utils/util";
import api from "../../utils/api";

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const TopMan = styled('img')({
  marginLeft: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const topMan = {
  position: 'relative',
  top: '74px',
  right: '14px'
}

const topContainer = {
  height: 295,
  backgroundImage: `url(${"../../src/assets/main/mainTop.png"})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};



const MainCheck = (props: { loading?: boolean }) => {

  const { loading = false } = props;





  return (
    <React.Fragment>

      <Stack direction={'row'} spacing={2} sx={{ m: 0, width: '100%', }}>

        <List sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', m: '15px 0' }} onClick={() => alert('기능 업데이트 중입니다.')}>
          <ListItem alignItems="center" >

            {loading ? (
              <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', width: '100%', }} justifyContent='center' alignContent={'center'}>
                <Skeleton animation="wave" variant="rounded" height={25} width='100%' sx={{ borderRadius: 3, my: 1 }} />
                <Skeleton animation="wave" variant="rounded" height={30} width='100%' sx={{ borderRadius: 3, }} />
                <Skeleton animation="wave" variant="circular" width={64} height={64} sx={{ ml: 'auto', mt: 2 }} />
              </Stack>
            ) : (
              <Stack direction={'column'} width={'100%'} sx={{}}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>건강검진 추천</Typography>
                <Typography sx={{ fontSize: 14, color: '#666' }}>나에게 맞는 건강검진 프로그램</Typography>
                <ListItemAvatar sx={{ bgcolor: '#FEF8F5', width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', ml: 'auto', mt: 1 }}>
                  <Avatar alt="" src={recom} sx={{ borderRadius: 0 }} />
                </ListItemAvatar>
              </Stack>
            )}  {/* Skeleton */}

          </ListItem>
        </List>

        {/* '심리 · 건강 상담' 카드 제거 — 심리 모듈이 이 프로젝트에 없어
            해당 경로로 이동하면 매칭되는 라우트가 없어 흰 화면이 됐다. */}
      </Stack>
    </React.Fragment>

  );
}

export default MainCheck;